import { Entry } from "./Entry";
import { Client } from "./Client";
import { BUDGET_STATUS } from "../_constants/budgets.constants";
import { Distributor } from "./Distributor";

export function Budget({
    uid,
    ref,
    date,
    distributor = Distributor(),
    client = Client(),
    status = BUDGET_STATUS.DRAFT,

    entries = [] || [Entry()],

    totalGrossPrice,
    totalVat,
    totalNetPrice,

    notes,
    vatApplied,
} = {}) {
    return {
        uid,
        ref,
        date,
        distributor,
        client,
        status,
        
        entries,

        totalGrossPrice,
        totalVat,
        totalNetPrice,
        
        notes,
        vatApplied,
    };
}